module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pl-dialog', {
    attrs: {
      "title": 'New Poll',
      "size": 'md',
      "disableOutsideClick": true
    },
    on: {
      "close": function($event) {
        return _vm.$emit('closePollDialog')
      }
    }
  }, [_c('body', {
    staticClass: "px-7 py-4 flex-grow overflow-y-auto"
  }, [_c('p', {
    staticClass: "font-semibold pb-2"
  }, [_vm._v("Question")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.question),
      expression: "question"
    }],
    ref: "input-title",
    staticClass: "bg-input text-sm flex-grow outline-none px-3 py-2 w-full rounded placeholder-gray-300",
    attrs: {
      "placeholder": 'Enter your question here',
      "type": "text",
      "maxlength": "120"
    },
    domProps: {
      "value": (_vm.question)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.question = $event.target.value
      }
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "font-semibold pt-4 pb-2"
  }, [_vm._v("Options")]), _vm._v(" "), _vm._l((_vm.answers), function(answer, index) {
    return _c('div', {
      key: ("answer-" + answer + "-" + index),
      staticClass: "flex justify-between items-center pb-2"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (answer.text),
        expression: "answer.text"
      }],
      staticClass: "bg-input text-sm flex-grow outline-none px-3 py-2 w-full rounded placeholder-gray-300",
      attrs: {
        "placeholder": ("Add option " + (index + 1)),
        "maxlength": "40"
      },
      domProps: {
        "value": (answer.text)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(answer, "text", $event.target.value)
        }
      }
    }), _vm._v(" "), (index > 1) ? _c('i', {
      staticClass: "fas fa-trash-alt w-5 mx-2 text-center text-red-200 hover:text-red-700 cursor-pointer",
      on: {
        "click": function($event) {
          return _vm.deleteAnswer(index)
        }
      }
    }) : _vm._e()])
  }), _vm._v(" "), (_vm.answers.length < 6) ? _c('div', {
    staticClass: "flex justify-between items-center"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.new_answer.text),
      expression: "new_answer.text"
    }],
    staticClass: "bg-input text-sm flex-grow outline-none px-3 py-2 w-full rounded placeholder-gray-300",
    attrs: {
      "placeholder": "Add another option",
      "maxlength": "40"
    },
    domProps: {
      "value": (_vm.new_answer.text)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.addAnswer()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.new_answer, "text", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "fas fa-plus-circle text-xl w-5 mx-2 text-center text-gray-400 hover:text-gray-700 cursor-pointer",
    on: {
      "click": _vm.addAnswer
    }
  })]) : _vm._e()], 2), _vm._v(" "), _c('footer', {
    staticClass: "flex justify-between items-center pt-5 pb-5 px-7"
  }, [_c('div', [_c('button', {
    staticClass: "w-24 py-2 bg-red-400 rounded text-white font-semibold",
    on: {
      "click": function($event) {
        return _vm.$emit('deletePoll')
      }
    }
  }, [_vm._v("\n        Delete\n      ")])]), _vm._v(" "), _c('div', [_c('button', {
    staticClass: "w-24 py-2 bg-gray-100 rounded text-gray-400 font-semibold",
    on: {
      "click": _vm.saveAndClose
    }
  }, [_vm._v("\n        Save\n      ")]), _vm._v(" "), (_vm.selectedPoll.live_discussion_id) ? _c('button', {
    staticClass: "w-24 py-2 ml-2 bg-primary rounded text-white font-semibold disabled:opacity-50",
    attrs: {
      "disabled": !_vm.question || !_vm.options_with_text
    },
    on: {
      "click": _vm.startPoll
    }
  }, [_vm._v("\n        Start\n      ")]) : _vm._e()])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-22eb1e62!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/features/polls_mvp/polls.create.vue
// module id = 1865
// module chunks = 61